import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const location = useLocation();
  const preventScroll = !!location.state && location.state.preventScroll;

  useEffect(() => {
    if (!preventScroll) window.scrollTo(0, 0);
  }, [location, preventScroll]);

  return children;
};

export default ScrollToTop;
